import React from 'react'
import { Spin } from 'antd'
import classnames from 'classnames'
import classes from './index.module.scss'
import FOModal from 'components/FOModal'
import { LoadingOutlined } from '@ant-design/icons'
const { styles } = classes
export const antLoadingIcon = <LoadingOutlined className='loading-icon' spin />

export const LoadingContent = (props) => {
  const { className, text = '' } = props
  return (
    <div
      className={classnames('spin', className)}
      style={{ textAlign: 'center' }}
      {...props}
    >
      <Spin indicator={antLoadingIcon} />
      {text && (
        <div
          style={{
            marginTop: '10px',
            fontSize: '16px',
            color: '#333',
            textAlign: 'center',
          }}
        >
          {text}
        </div>
      )}
    </div>
  )
}

const LoadingDialog = ({ visible, setVisible, center, className } = {}) => {
  return (
    <FOModal
      {...{ visible, setVisible }}
      className={classnames(styles)}
      center={center}
    >
      <LoadingContent />
    </FOModal>
  )
}

export default LoadingDialog
